<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
    import { getters} from './contract'

    const descriptions = {
    	compound: 'A swerve.fi portal for swapping cDAI/cUSDC',
    	usdt: 'A swerve.fi Tethered portal for swapping cDAI/cUSDC/USDT',
    	swusd: 'A swerve.fi yTokens portal for swapping DAI/USDC/USDT/TUSD',
    	busd: 'A swerve.fi portal for swapping BUSD and other stablecoins',
    }

    const titles = {
    	compound: 'Compounded',
    	usdt: 'Tethered',
    	swusd: 'Yield',
    	busd: 'bUSD',
    	susd: 'sUSD-yCurve old',
    	susdv2: 'sUSD',
        pax: 'PAX',
        tbtc: 'TBTC',
        ren: 'renBTC',
        sbtc: 'sBTC',
    }

	export default {
		metaInfo() {
			return {
                title: "Swerve.fi",
				meta: [
				]
			}
		},
        computed: {
          ...getters,
        },
	}
</script>
